// #region imports

// --- Angular
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

// --- RxJs

// --- HS Code
import { Constants, GroupModel, RespondentModel, SurveyResponseModel } from '../../../models';

// #endregion

@Component({
  selector: 'hs-manage-respondents-v2',
  templateUrl: './manage-respondents-v2.component.html',
  styleUrls: ['./manage-respondents-v2.component.scss']
})
export class ManageRespondentsV2Component implements OnChanges {

  @Input() groups: GroupModel[] | null = null;
  @Input() surveyResponse: SurveyResponseModel | null = null;
  @Input() isMobile: boolean | null = false;
  @Input() isMobileUser: boolean = false;

  @Output() addRespondent = new EventEmitter<{}>();
  @Output() addGroupClicked = new EventEmitter<SurveyResponseModel>();
  @Output() deleteRespondent = new EventEmitter<RespondentModel>();
  @Output() moveRespondent = new EventEmitter<{}>();
  @Output() editGroupName = new EventEmitter<GroupModel>();
  @Output() remindRespondentClick = new EventEmitter<RespondentModel>();

  availableGroupsForMoves: GroupModel[] = [];
  maximumNumberOfRespondentsPerGroup: number = Constants.NUMBER_OF_RESPONDENTS_PER_GROUP;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['groups']) {
      if (this.groups === null) return;

      const activeGroup = this.groups.find(g => g.isActiveGroup);
      if (!activeGroup && this.groups.length > 0) {
        this.groups[0].isActiveGroup = true;
      }

      this._setAvailableGroupsForMoves();
    }
  }

  onToggleVisibility(groupIndex: number) {
    if (this.groups === null) return;

    for (const group of this.groups) {
      if (group.index !== groupIndex) {
        group.isActiveGroup = false;
      }
    }
  }

  private _setAvailableGroupsForMoves(): void {
    if (!this.groups) return;
    if (!this.surveyResponse) return;

    const numberOfRespondentsPerGroup = this.surveyResponse.numberOfRespondentsPerGroup;

    this.availableGroupsForMoves = this.groups.filter(
        (g) => g.respondents.filter(r => !!r.emailAddress).length < numberOfRespondentsPerGroup);
  }
}
